<template>
  <b-row>
    <RegionOverview :lgSize="12"></RegionOverview>
    <ChartNormal
      size="6"
      offset="0"
      title="Received Equipment"
      chart="pie"
      chartType="Received"
      :withDate="true"
      :withFinancial="false"
    />
    <ChartNormal
      size="6"
      offset="0"
      title="Delivered Equipment"
      chart="pie"
      chartType="Shipped"
      :withDate="true"
      :withFinancial="false"
    />
    <ChartNormal
      size="6"
      offset="0"
      title="Recycled At Screening"
      chart="pie"
      chartType="units"
      :withDate="false"
      :withFinancial="false"
      :units="true"
    />
    <ChartNormal
      size="6"
      offset="0"
      title="Tested"
      chart="pie"
      chartType="tested"
      :tested="true"
      :withDate="false"
      :withFinancial="false"
    />
    <ChartNormal
      size="6"
      offset="0"
      title="Active Backlog"
      chart="column"
      chartType="backlog"
      :backlog="true"
      :withDate="false"
      :withFinancial="false"
    />
    <ChartNormal
        size="6"
        offset="0"
        title="Warranty Repair"
        chart="column"
        chartType="warranty-repair"
        :warrantyRepair="true"
        :withDate="false"
        :withFinancial="false"
      />
    <ChartNormal
      size="6"
      offset="0"
      title="Arrival Date On Dock"
      chart="pie"
      chartType="arrivalDate"
      :arrivalDate="true"
      :withDate="false"
      :withFinancial="false"
    />
      <ChartNormal
        size="6"
        offset="0"
        title="Inventory Status"
        chart="pie"
        chartType="inventory_status"
        :inventoryStatus="true"
        :withDate="false"
        :withFinancial="false"
      />
  </b-row>
</template>

<script>
import ChartNormal from "../../../components/chart/chartNormal";
import ChartStacked from "../../../components/chart/chartStacked";
import RegionOverview from "../../../components/region_overview/RegionOverview.vue";

export default {
  name: "Dashboard",
  components: {
    ChartNormal,
    ChartStacked,
    RegionOverview
  }
};
</script>

<style>
.vdp-datepicker__calendar {
  position: absolute !important;
  z-index: 100;
  background: #3a4149 !important;
  width: 300px;
  border: 1px solid #ccc;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #515b65 !important;
  opacity: 1 !important;
}
/* IE fix */
#card-chart-01,
#card-chart-02 {
  width: 100% !important;
}
.highcharts-label {
  color: #00bf8f !important;
  fill: #00bf8f !important;
}

.power {
  background-color: #f86c6b !important;
}
</style>
